import React from "react";
import { Workflow, BCMSDate, BCMSRecord, useBCMSContext, useParams, useModel } from "@bcm-dev/bcms-vite";
import { Transaction } from "model";
import DisputeTransactionPage from "components/pages/DisputeTransactionPage";
import DisputeContactView from "components/pages/DisputeTransactionPage/components/DisputeContactView";
import DisputeReasonView from "components/pages/DisputeTransactionPage/components/DisputeReasonView";
import DisputeSubmittedView from "components/pages/DisputeTransactionPage/components/DisputeSubmittedView";
import DisputeTransactionView from "components/pages/DisputeTransactionPage/components/DisputeTransactionView";
import DisputeTransactionReasonView from "components/pages/DisputeTransactionPage/components/DisputeTransactionReasonView";
import DisputeTransactionStartPage from "components/pages/DisputeTransactionPages/DisputeTransactionStartPage";
import DisputeTransactionReasonPage from "components/pages/DisputeTransactionPages/DisputeTransactionReasonPage";
import DisputeServiceReasonView from "components/pages/DisputeTransactionPage/components/DisputeServiceReasonView";
import DisputeItemServiceView from "components/pages/DisputeTransactionPage/components/DisputeItemServiceView";
import DisputeMerchandiseReasonView from "components/pages/DisputeTransactionPage/components/DisputeMerchandiseReasonView";
import DisputeItemServicePage from "components/pages/DisputeTransactionPages/DisputeItemServicePage";
import DisputeMerchandiseReasonPage from "components/pages/DisputeTransactionPages/DisputeMerchandiseReasonPage";
import DisputeAmountPage from "components/pages/DisputeTransactionPages/DisputeAmountPage";
import DisputeContactResolvePage from "components/pages/DisputeTransactionPages/DisputeContactResolvePage";
import DisputeDissatisfiedConfirmPage from "components/pages/DisputeTransactionPages/DisputeDissatisfiedConfirmPage";
import DisputeServiceReasonPage from "components/pages/DisputeTransactionPages/DisputeServiceReasonPage";
import DisputeContactPage from "components/pages/DisputeTransactionPages/DisputeContactPage";

const steps = [
    DisputeTransactionStartPage,
    //<DisputeTransactionPage view={ <DisputeTransactionView /> }/>,
    //<DisputeTransactionPage view={ <DisputeContactView /> }/>,
    //<DisputeTransactionPage view={ <DisputeReasonView /> }/>,
    DisputeTransactionReasonPage,
    DisputeItemServicePage,
    DisputeMerchandiseReasonPage,
    DisputeAmountPage,
    DisputeContactResolvePage,
    DisputeDissatisfiedConfirmPage,
    DisputeServiceReasonPage,
    DisputeContactPage
    //<DisputeTransactionPage view={ <DisputeTransactionReasonView /> }/>,
    //<DisputeTransactionPage view={ <DisputeSubmittedView /> }/>
];
//workflowStep.workflow.goStep(2,{transfer:transfer.setDefaults()})  
/**
 * @function DisputeTransactionWorkflow
 * @returns {React.Component}
 * @description The main component for the dispute transaction workflow.
 * @exported true
 * @example <DisputeTransactionWorkflow />
 */
export default function DisputeTransactionWorkflow(props) {
    const globalController = useBCMSContext();
    const transactionID = useParams().transactionID ?? "0";
    const value = getDefault(globalController, transactionID);
    return <Workflow value={ value } steps={ steps } />;
}

/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @returns {OBJECT}
 * @exported true
 * @description Returns the default values for the dispute transaction
 */
export const getDefault = (controller, transactionID) => {
    BCMSRecord.globalControllerFor([ Transaction ], controller);
    const transaction = Transaction.initByID(transactionID);

    return {
        transaction: transaction,
        didUserMakeThisTransaction: undefined,
        disputeReason: "",
        disputeReasonAdditionalComments: "",
        confirmationNumber: "42101123000",
        disputeSubmissionDate: BCMSDate.init()
    }
};